<div class="profile-card">
    <ng-container *ngIf="hasHeader">
        <div class="row profile-card-header">
            <!-- <div class="col-12" [ngSwitch]="headerSize">
                <ng-container *ngSwitchCase="1">
                    <div class="profile-card-header-1">
                        
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                    <div class="profile-card-header-2 row">
                        <div class="col-12">
                            <h3>{{config.headerText}}</h3>
                        </div>
                    </div>
                </ng-container>
            </div> -->
            <div class="col-12">
                <h3>
                    {{config.headerText}}
                </h3>
            </div>
        </div>
    </ng-container>
    <div class="row profile-card-content">
        <div class="col-12">
            <ng-content></ng-content>
        </div>
    </div>
</div>